module.exports = __webpack_public_path__ + "images/avatars/male/8.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/8.svg
// module id = 2wJH
// module chunks = 51